import { Icon } from "./icons";

export function SuccessIcon() {
	return (
		<span>
			<Icon
				name="BadgeCheck"
				className="stroke-emerald-500"
			/>
		</span>
	);
}
